import { Typography, TextField } from "@mui/material";
import { styled } from "@mui/material/styles";
const Container = styled("div")`
  display: flex;
  width: 264px;
  padding: 12px;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
`;
const Title = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[800]
}));
const CommentField = styled(TextField)(({ theme }) => ({
  "&& .MuiInputBase-root": {
    margin: "12px 0",
    padding: "8px",
    minWidth: "240px",
    height: "120px",
    boxSizing: "border-box",
    background: theme.palette.grey[50],
    "&:hover": {
      background: theme.palette.grey[50]
    }
  },
  "&& .MuiInputBase-input": {
    margin: "12px 0",
    minWidth: "240px",
    height: "120px",
    boxSizing: "border-box"
  }
}));
const Footer = styled("div")`
  align-self: flex-end;
  display: flex;
  gap: 8px;
`;
const FormContainer = styled("form")`
  display: flex;
  gap: 12px;
  flex-direction: column;
  width: 100%;
`;
export {
  CommentField,
  Container,
  Footer,
  FormContainer,
  Title
};
